/**
 * Trecho injetado no script de checkpoints (export + App.jsx) para modo pagamento Asaas.
 * Escopo: ckIds, ckModes, markDone, update, doneArr, key, total
 *
 * Chave localStorage inclui cmid + fingerprint do botão (valor/descrição) para não reutilizar
 * pagamento confirmado noutra atividade ou após alterar preço no Geppetto.
 */
export const GEPPETTO_ASAAS_PAYMENT_CHECKPOINT_SNIPPET = `
    ckIds.forEach(function(pid, idx) {
      if (ckModes[idx] !== "payment") return;
      var wrap = document.getElementById("madri-ck-" + pid);
      if (!wrap) return;
      var cmid = wrap.getAttribute("data-gep-cmid");
      var sk = wrap.getAttribute("data-gep-sesskey");
      if (!cmid || !sk) return;
      var btn = wrap.querySelector(".madri-asaas-pay-btn");
      if (!btn) return;
      var paidNote = wrap.querySelector(".madri-asaas-paid-note");
      var ajaxUrl = (function() {
        var base = (window.geppettoMoodleWwwroot || window.location.origin || '').replace(/\\/$/, '');
        return base + "/lib/ajax/service.php?sesskey=" + encodeURIComponent(sk);
      })();
      var LS_ASAAS = "gepetto_asaas_pend_v2";
      function payFpFromBtn(b) {
        var a = (b.getAttribute("data-amount") || "").trim();
        var d = (b.getAttribute("data-description") || "").trim().slice(0, 120);
        return a + "|" + d;
      }
      var payFp = payFpFromBtn(btn);
      var storageKey = String(cmid) + "|" + String(pid) + "|" + String(idx) + "|" + payFp;
      var POLL_MS = 8000;
      var MAX_POLLS_PER_VISIT = 450;

      function setPaidUi() {
        if (btn) { btn.style.display = "none"; btn.disabled = true; }
        if (paidNote) paidNote.style.display = "block";
      }
      if (doneArr.indexOf(idx) >= 0) {
        try {
          var m0 = JSON.parse(localStorage.getItem(LS_ASAAS) || "{}");
          if (m0 && m0[storageKey]) { delete m0[storageKey]; localStorage.setItem(LS_ASAAS, JSON.stringify(m0)); }
        } catch (e0) {}
        setPaidUi();
        return;
      }

      var pollTimer = null;
      var pollCount = 0;
      function stopPoll() {
        if (pollTimer) { clearInterval(pollTimer); pollTimer = null; }
      }

      function moodleSaveCheckpointBackup() {
        var dc = Array.from(new Set(doneArr)).length;
        fetch(ajaxUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify([{
            index: 0,
            methodname: "mod_gepettoresource_save_checkpoint",
            args: {
              cmid: parseInt(cmid, 10),
              checkpointindex: idx,
              total: total,
              donecount: dc
            }
          }])
        }).catch(function() {});
      }

      function onPaidConfirmed() {
        stopPoll();
        try {
          var m1 = JSON.parse(localStorage.getItem(LS_ASAAS) || "{}");
          if (m1 && m1[storageKey]) { delete m1[storageKey]; localStorage.setItem(LS_ASAAS, JSON.stringify(m1)); }
        } catch (e1) {}
        markDone(idx);
        moodleSaveCheckpointBackup();
        setPaidUi();
      }

      function pollTick(extRef) {
        if (typeof document !== "undefined" && document.visibilityState === "hidden") return;
        pollCount++;
        if (pollCount > MAX_POLLS_PER_VISIT) { stopPoll(); return; }
        fetch(ajaxUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify([{
            index: 0,
            methodname: "mod_gepettoresource_asaas_payment_status",
            args: { cmid: parseInt(cmid, 10), externalreference: extRef }
          }])
        })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (!data || !data[0] || data[0].error) return;
          var d = data[0].data;
          if (d && d.paid) onPaidConfirmed();
        })
        .catch(function() {});
      }

      function pollExt(extRef) {
        stopPoll();
        pollCount = 0;
        pollTick(extRef);
        pollTimer = setInterval(function() { pollTick(extRef); }, POLL_MS);
      }

      function readPendingExt() {
        try {
          var m = JSON.parse(localStorage.getItem(LS_ASAAS) || "{}");
          var e = m[storageKey];
          if (!e || !e.ext) return null;
          if (Date.now() - (e.t || 0) > 45 * 24 * 60 * 60 * 1000) {
            delete m[storageKey];
            localStorage.setItem(LS_ASAAS, JSON.stringify(m));
            return null;
          }
          var curFp = payFpFromBtn(btn);
          if (e.fp && e.fp !== curFp) {
            delete m[storageKey];
            localStorage.setItem(LS_ASAAS, JSON.stringify(m));
            return null;
          }
          return e.ext;
        } catch (e2) { return null; }
      }

      var pendingExt = readPendingExt();
      if (pendingExt) pollExt(pendingExt);

      btn.addEventListener("click", function() {
        if (btn.disabled) return;
        btn.disabled = true;
        var desc = btn.getAttribute("data-description") || "";
        var amount = parseFloat(btn.getAttribute("data-amount") || "0");
        fetch(ajaxUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify([{
            index: 0,
            methodname: "mod_gepettoresource_asaas_payment_start",
            args: {
              cmid: parseInt(cmid, 10),
              widgetid: String(pid),
              checkpointindex: parseInt(btn.getAttribute("data-ck-index") || "0", 10),
              amount: amount,
              description: desc
            }
          }])
        })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          btn.disabled = false;
          if (!data || !data[0] || data[0].error) {
            try {
              var ex = data && data[0] && data[0].exception;
              var msg = ex && ex.message ? ex.message : "Não foi possível iniciar o pagamento.";
              if (typeof console !== "undefined" && console.warn) {
                console.warn("[Geppetto Asaas]", msg, data && data[0]);
              }
              alert(msg);
            } catch (e3) {}
            return;
          }
          var d = data[0].data;
          var url = d && d.invoice_url;
          var ext = d && d.external_reference;
          if (!url || !ext) return;
          var fpNow = payFpFromBtn(btn);
          try {
            var m2 = JSON.parse(localStorage.getItem(LS_ASAAS) || "{}");
            m2[storageKey] = { ext: ext, t: Date.now(), fp: fpNow };
            localStorage.setItem(LS_ASAAS, JSON.stringify(m2));
          } catch (e4) {}
          try { window.open(url, "_blank", "noopener,noreferrer"); } catch (e5) { window.location.href = url; }
          pollExt(ext);
        })
        .catch(function() { btn.disabled = false; });
      });
    });
`;
